// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { getProgynyWizardCycle } from '~shared/selectors/checkout/progyny';
import { type FertilityCycle, type ReduxStateShared } from '~shared/types';

export const getInProgynyWizard: (state: ReduxStateShared) => boolean = createSelector(
  [getProgynyWizardCycle],
  (cycle: FertilityCycle | null | undefined) => {
    return !!cycle;
  },
);
